var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35694 16.4871C4.60038 16.9435 3.66701 16.2663 3.86614 15.4055L4.82292 11.2693C4.90639 10.9084 4.78357 10.531 4.50371 10.2883L1.29358 7.50517C0.626052 6.92645 0.982002 5.82975 1.86216 5.75335L6.10848 5.38474C6.47766 5.3527 6.79884 5.11912 6.94311 4.77779L8.58749 0.887071C8.93163 0.0728009 10.0856 0.0728009 10.4297 0.887061L12.0741 4.77779C12.2184 5.11912 12.5395 5.3527 12.9087 5.38474L17.155 5.75335C18.0352 5.82975 18.3912 6.92645 17.7236 7.50518L14.5135 10.2883C14.2336 10.531 14.1108 10.9084 14.1943 11.2693L15.1511 15.4055C15.3502 16.2663 14.4168 16.9435 13.6603 16.4871L10.0251 14.2943C9.7074 14.1026 9.30976 14.1026 8.99207 14.2943L5.35694 16.4871Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8369 1.68652L14.0898 2.81892",
    stroke: "#CCBE6F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9754 11.6126L16.4047 11.2456",
    stroke: "#CCBE6F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58091 17.7013L9.58203 16.5166",
    stroke: "#CCBE6F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02093 11.5085L2.56209 11.2221",
    stroke: "#CCBE6F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32258 1.61279L5.06015 2.73993",
    stroke: "#CCBE6F",
    strokeWidth: 1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightStar);
export default __webpack_public_path__ + "static/media/bright_star.85ec3c6cf7305739d59e215d422577fd.svg";
export { ForwardRef as ReactComponent };